import { useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";
import { financeState } from "web_myplann/Finances/State/FinanceAtom";

export const useSyncFinanceState = (enabled = true) => {
	const { incomeEntries, expenseEntries, isSuccess } = useFinanceEntries();

	const setFinance = useSetAtom(financeState);
	const [isHydrated, setIsHydrated] = useState(false);

	useEffect(() => {
		if (!enabled || !isSuccess || isHydrated) {
			return;
		}

		setFinance({ income: incomeEntries, expenses: expenseEntries });
		setIsHydrated(true);
	}, [
		enabled,
		isSuccess,
		isHydrated,
		incomeEntries,
		expenseEntries,
		setFinance,
	]);

	return { isHydrated };
};
